import type React from 'react';
import { ListBox } from '@heroui/react';
import { ALL_BRANCHES_KEY, type BranchFilterOption } from './branchScopeMeta';

type BranchPickerOptionsProps = {
    /** The organisation's branches, after All branches. */
    branches: BranchFilterOption[];
    /** The localized All branches option, the picker's default. */
    allBranchesLabel: string;
};

/**
 * A branch picker's options: All branches, then each branch by name. Shared
 * by the list's filters drawer (bos-app#118) and the product details page
 * (bos-app#119), so the two pickers offer the same choice under the same
 * keys.
 */
export const BranchPickerOptions: React.FC<BranchPickerOptionsProps> = ({
    branches,
    allBranchesLabel,
}) => (
    <ListBox>
        <ListBox.Item id={ALL_BRANCHES_KEY} textValue={allBranchesLabel}>
            {allBranchesLabel}
            <ListBox.ItemIndicator />
        </ListBox.Item>
        {branches.map((branch) => (
            <ListBox.Item
                id={branch.id}
                key={branch.id}
                textValue={branch.name}
            >
                {branch.name}
                <ListBox.ItemIndicator />
            </ListBox.Item>
        ))}
    </ListBox>
);
